<div
	#buttonElement
	class="flex items-center justify-center text-secondary-800 cursor-pointer h-full text-sm p-2 select-none focus-visible-border focus-visible:outline-none"
	[class]="
		primary() && disabled()
			? 'text-secondary-400! cursor-not-allowed! bg-white hover:bg-white'
			: primary()
				? 'text-white dark:text-secondary-800 bg-primary-700 hover:bg-primary-900 cursor-pointer'
				: disabled()
					? 'text-secondary-400 cursor-not-allowed bg-white hover:bg-white'
					: 'text-secondary-400 cursor-not-allowed'
	"
	(click)="click($event)"
	(keydown)="onKeyDown($event)"
	[tabindex]="disabled() ? -1 : tabindex()"
>
	@if (icon()) {
		<ui-icon class="mr-1" [icon]="icon()"></ui-icon>
	}
	<span>
		{{ label() }}
	</span>
</div>
